import { makeStyles } from '@material-ui/core/styles';
import { componentDimensions } from 'UI/constants/dimensions';
import { colors } from 'UI/res';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    ...flexAlignCenterJustifyCenter,
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
    flex: 1,
    height: ({ height }) => height || '90%',
    backgroundColor: colors.transparent,
    padding: theme.spacing(2),
    position: 'relative'
  },
  defaultEmptyState: {
    maxWidth: componentDimensions.emptyState.width
  },
  title: {
    color: theme.palette.grey[900]
  },
  subtitle: {
    color: theme.palette.grey[600]
  },
  textContainer: {
    height: '100%',
    ...flexAlignCenterJustifyCenter
  },
  children: {
    margin: theme.spacing(1.5, 0, 0)
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));
